const footerLite = {
  thRoot:
    'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
  thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
  thIconWidth: '1.5625rem',
  thSText: 'hidden sm:block font-normal text-base text-gray-darker',
};

export const themes = {
  default: {
    thRoot:
      'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-1',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase',
  },
  black: {
    thRoot:
      'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking',
  },
  footerLite,
  contact: {
    thRoot:
      'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light',
  },
  contact2: {
    thRoot:
      'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker',
  },
  smallFooterLite: {
    ...footerLite,
    thIconWidth: '1.2rem',
  },
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white',
  },
};
